// tslint:disable: trailing-comma
// tslint:disable:no-any
import { IPrice } from './price.interface';
import { ISalesDocument } from './sales-document.interface';

export interface IProduct {
  commercialCode: string;
  commercialDesc: string;
  productId: number;
  productLine: {
    productLineId: string
  };
  unitOfMeasure: {
    links: any
    unitId: number
  };
  salesDocument?: ISalesDocument;

  unitaryPrice?: IPrice;
  product: {
    links: any
    productId: number
    productLine: {
      links: any
      productLineId: number
    }
  };
}
